import React from 'react'
import {Link} from 'react-router-dom'

function BlogGrid() {
  return (
    <div>
    <div className="section-bg section-padding subheader" style={{ backgroundImage: 'url(/tm/react/fit2fine/assets/images/subheader.jpg)' }}>
        <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                    <h1 className="text-white page-title">Blog Grid</h1>
                </div>
            </div>
        </div>
    </div>
    {/* <!-- Subheader End -->
    <!-- Section Start --> */}
    <section className="section-padding">
        <div className="container">
            <div className="row justify-content-center">
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/1.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        20 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">You Will Become As Off Small Your Desire. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
             
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/2.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        18 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">10 Tips How to Prepare Meals Fast and Easy. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/3.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        15 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/4.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        14 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">Simple Condition for all Around Fitness. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
               
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/5.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        14 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/6.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        10 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">How to Maximise Time Spent at the Gym. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/7.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        09 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">A Moments of Fit. </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/8.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        5 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">Turn Fat Into Fit </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
                
                <article className="col-lg-4 col-md-6">
                    <div className="post post_grid">
                        <div className="post_image">
                            <Link to="/blog-details" className="d-flex h-100">
                                <img src="/tm/react/fit2fine/assets/images/blog/9.jpg" alt="img" className="image-fit"/>
                            </Link>
                        </div>
                        <div className="post_caption">
                            <ul className="post_meta">
                                <li>
                                    <Link to="/blog-details">
                                        <i className="bi-calendar3"></i>
                                        1 Fab 2024
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/blog-grid">
                                        <i className="bi-person"></i>
                                        by Admin
                                    </Link>
                                </li>
                            </ul>
                            <h2 className="post_title">
                                <Link to="/blog-details">Dare To Be Great </Link>
                            </h2>
                            <p className="post_desc mb-0">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore.</p>
                        </div>
                        <div className="post_footer">
                            <Link to="/blog-details" className="thm-btn w-100">Read More</Link>
                        </div>
                    </div>
                </article>
            </div>
            <div className="row">
                <div className="col-12">
                    <nav>
                    <ul className="pagination">
                        <li className="page-item">
                            <Link className="page-link" to="#">
                                Previous
                            </Link>
                        </li>
                        <li className="page-item active"><Link className="page-link" to="#">1</Link></li>
                        <li className="page-item"><Link className="page-link" to="#">2</Link></li>
                        <li className="page-item"><Link className="page-link" to="#">3</Link></li>
                        <li className="page-item">
                            <Link className="page-link" to="#">
                                Next
                            </Link>
                        </li>
                    </ul>
                    </nav>
                </div>
            </div>
        </div>
    </section>
    </div>
  )
}

export default BlogGrid